import { useMemo, useState } from "react";
import useGallery from "@/hooks/useGallery";
import GalleryGrid from "@/components/GalleryGrid";
import Lightbox from "@/components/Lightbox";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

export default function VideoClipsPage() {
  const { items, loading } = useGallery();
  const videos = useMemo(() => items.filter((i) => i.type === "video"), [items]);
  const [activeId, setActiveId] = useState(null);

  return (
    <div className="px-5 sm:px-8 lg:px-10 pt-10 lg:pt-12 pb-16">
      <Seo
        title="Video Clips"
        description="Short clips, project films, social content, drone footage, and site progress videos."
        path="/video-clips"
      />
      <PageHeader
        eyebrow="Motion"
        title="Video Clips"
        intro="Short clips, project films, social content, drone footage, and site progress videos."
        testid="video-clips-header"
      />
      <div className="mt-10">
        {loading ? (
          <div className="text-[#737373] text-xs tracking-[0.24em] uppercase py-20 text-center">
            Loading…
          </div>
        ) : (
          <GalleryGrid items={videos} onOpen={setActiveId} />
        )}
      </div>
      {activeId !== null && (
        <Lightbox
          items={videos}
          activeId={activeId}
          onClose={() => setActiveId(null)}
          onChange={setActiveId}
        />
      )}
    </div>
  );
}
